import { Button, Group, Modal, Stack, Text } from "@assetwatch/ui";
import { UnsavedChangesDialog } from "../UnsavedChangesDialog";

export type PendingProcedureDelete = {
  kind: "section" | "group";
  groupId: string | null;
  id: string;
  label: string;
  hasContents: boolean;
  canKeepContents: boolean;
};

export function ProcedureDeleteDialog({
  request,
  onOpenChange,
  onDelete,
  onKeepContents,
}: {
  request: PendingProcedureDelete | null;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
  onKeepContents: () => void;
}) {
  return (
    <Modal
      open={request !== null}
      onOpenChange={onOpenChange}
      title={`${request?.kind === "group" ? "Delete heading" : "Delete section"}?`}
      size="md"
    >
      {request ? (
        <Stack gap={16}>
          <Text tone="subtle">
            “{request.label}”{" "}
            {request.hasContents
              ? "contains steps. Keep its contents in the neighboring structure or delete everything inside it."
              : "will be removed."}
          </Text>
          <Group justify="end" gap={8} wrap="wrap">
            <Button onClick={() => onOpenChange(false)} variant="ghost">
              Cancel
            </Button>
            {request.hasContents && request.canKeepContents ? (
              <Button onClick={onKeepContents} variant="outline">
                Keep contents
              </Button>
            ) : null}
            <Button intent="destructive" onClick={onDelete}>
              Delete {request.hasContents ? "everything" : "structure"}
            </Button>
          </Group>
        </Stack>
      ) : null}
    </Modal>
  );
}

export function ProcedureLeaveDialog({
  open,
  onOpenChange,
  onDiscard,
  onSave,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
  onSave: () => void;
}) {
  return (
    <UnsavedChangesDialog
      description="Save your changes before leaving this Procedure?"
      onDiscard={onDiscard}
      onKeepEditing={() => onOpenChange(false)}
      onSave={onSave}
      open={open}
    />
  );
}
